import React, { useEffect } from 'react';
import './style.scoped.css';

export interface BottomSheetProps {
  visible: boolean;
  children?: React.ReactNode;
  showIndicator?: boolean;
  onClose?: () => void;
  darkOverlay?: boolean;
}

const BottomSheet = (props: BottomSheetProps) => {
  const {
    visible,
    children,
    showIndicator = true,
    onClose,
    darkOverlay = false,
  } = props;

  useEffect(() => {
    if (visible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
  }, [visible]);

  if (!visible) return <div />;
  return (
    <div
      className="bottomSheetOverlay"
      style={{
        backgroundColor: darkOverlay ? 'rgba(0, 0, 0, 0.2)' : 'transparent',
      }}
    >
      <div className="flex-1" />
      <div className="bottomSheetContainer">
        {showIndicator && <div className="indicator" />}
        {children}
      </div>
    </div>
  );
};
export default BottomSheet;
